// extracted by mini-css-extract-plugin
export default {"wrapper":"HomeSection_wrapper__Y+p4P","content":"HomeSection_content__Seidj","greeting":"HomeSection_greeting__cagva","slide-bottom":"HomeSection_slide-bottom__5kKtn"};